/*
	This is a simple component to simplify using a Rhombus ProgressIndicator, and its two most common pitfalls.

	1. In order to be sized properly, a ProgressIndicator needs to be the child of a relative positioned container.

	2. When ProgressIndicator is used with scrolling content, you get an absolutely positioned element
	with a spinner that scrolls away with the top of the content, which is bad.

	ProgressContainer sets up a container that doesn't move, and a child scrollable div,
	containing the ProgressIndicator and ProgressContainer's children, so long content can be scrolled as normal,
	but the ProgressIndicator stays put and blocks everything when its `isLoading` prop is true.

	---

	Any props besides the `className` will be forwarded to the ProgressIndicator.
	`className` will be applied to the top level container.

	Example Usage:
	```
		function TallModal(props){
			const isLoading = useSelector(...);
			const modalProps = {
				renderContent(){
					return (
						<ProgressContainer isLoading={isLoading}>
							<LongContent />
						</ProgressContainer>
					);
				}
			}
			return <BasicModal {...modalProps} />;
		}
	```
*/

import React from "react";
import { ProgressIndicator } from "rhombus-react";

import "./ProgressContainer.css";

export default function ProgressContainer(props){
	const {
		children,
		className="",
		...progressIndicatorProps
	} = props;
	return (
		<div className={`progress-container ${className}`}>
			<div className="progress-container-scrollable">
				<ProgressIndicator {...progressIndicatorProps} />
				{children}
			</div>
		</div>
	);
}

ProgressContainer.displayName = "ProgressContainer";
